import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { authAPI } from "../../apis";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import InputPassword from "../../components/input/InputPassword";
import { validateUserPassword } from "../../functions/validation";


const ChangeForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();


  const [password, setpassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [loading, setloading] = useState(false);

  async function onSubmitLogin(e) {
    e.preventDefault();

    if (!validateUserPassword(password)) {
      toast.error("Please enter a valid password");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Password do not match");
      return;
    }

    try {
      setloading(true);

      const res = await axios.post(authAPI.resetPasswrd, {
        userId: searchParams.get("userId"),
        code: searchParams.get("code"),
        resetPassword: password,
        resetConfirmPassword: confirmPassword,
      });

      if (res.data) {
        toast.success(res.data.message);
        navigate("/");
      }
      setloading(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.title);
      setloading(false);
    }
  }

  return (
    <form onSubmit={onSubmitLogin}>
      <h1>Reset Password</h1>

      <InputPassword
        placeholder="Please enter a new valid password"
        value={password}
        onChange={(e) => setpassword(e.target.value)}
      />

      <InputPassword
        placeholder="Confirm new password"
        value={confirmPassword}
        onChange={(e) => setconfirmPassword(e.target.value)}
      />
      <p className="message">
        NOTE: Password should be minimum 8 characters with at least one
        uppercase letter, one lowercase letter, one special character and one
        number.
      </p>

      <ButtonPrimary text="Continue" loading={loading} />
    </form>
  );
};

export default ChangeForm;
